import '../../App.css'
import React from "react";

export default function Mac() {
    return (
      <h2>Mac Setup</h2>
    
    );
  }